/* Publish by EComposer at 2026-10-11 21:34:10*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2hh87y1e6ra"]=  window.__ectimmers["ecom-2hh87y1e6ra"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-2hh87y1e6ra').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2hh87y1e6ra', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hruep97m5wt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hruep97m5wt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lu5k48vlnd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lu5k48vlnd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5o3sq8vwfji').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5o3sq8vwfji', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2wqff7vnh34').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2wqff7vnh34', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-bkismdz1pm4"]=  window.__ectimmers["ecom-bkismdz1pm4"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-bkismdz1pm4"]["3ze54q2vg"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-bkismdz1pm4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bkismdz1pm4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0q5qdavkxfb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0q5qdavkxfb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-66gcu7vqaae').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-66gcu7vqaae', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8qihc0t5s14').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8qihc0t5s14', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tdivguuqk5l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tdivguuqk5l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-av18xwbx1cs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-av18xwbx1cs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xx17gfutk6l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xx17gfutk6l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2thl14cde36').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2thl14cde36', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}